import { TrText } from "../components/TrText";
import { TrSpace } from "../components/TrSpace";
import { TrTextField } from "../components/TrTextField";
import { FormPageButton } from "../components/FormPageButton";
import { useState, useCallback, createContext } from "react";
import { useDispatch } from "react-redux";
import { setPurchaserInfo } from "../reducks/orders/operations";
import { Select } from "../components/Select";
import { RadioButton } from "../components/RadioButton";
import { TrTextArea } from "../components/TrTextArea";

export const DateOfBirthContext = createContext();

export const InputPurchaserInfo = () => {
    const dispatch = useDispatch()

    const [purchaser, setPurchaser] = useState("")
    const [furigana, setFurigana] = useState("")
    const [email, setEmail] = useState("")
    const [isAlertForPurchaser, setIsAlertForPurchaser] = useState(false)
    const [isAlertForFurigana, setIsAlertForFurigana] = useState(false)
    const [isAlertForEmail, setIsAlertForEmail] = useState(false)
    const [year, setYear] = useState("")
    const [month, setMonth] = useState("")
    const [day, setDay] = useState("")
    const [sex, setSex] = useState("")
    const [howDidChermoKnow, setHowDidChermoKnow] = useState("")
    const [otherSpecificContent, setOtherSpecificContent] = useState("")

    const inputPurchaser = useCallback((event) => {
        setPurchaser(event.target.value);
    }, [setPurchaser])

    const inputFurigana = useCallback((event) => {
        setFurigana(event.target.value);
    }, [setFurigana])

    const inputEmail = useCallback((event) => {
        setEmail(event.target.value);
    }, [setEmail])


    const inputYear = useCallback((event) => {
        setYear(event.target.value);
    }, [setYear])

    const inputMonth = useCallback((event) => {
        setMonth(event.target.value);
    }, [setMonth])

    const inputDay = useCallback((event) => {
        setDay(event.target.value);
    }, [setDay])

    const inputSex = useCallback((event) => {
        setSex(event.target.value);
    }, [setSex])

    const inputHowDidChermoKnow = useCallback((event) => {
        setHowDidChermoKnow(event.target.value);
    }, [setHowDidChermoKnow])

    const inputOtherTextAreaValue = useCallback((event) => {
        setOtherSpecificContent(event.target.value);
    }, [setOtherSpecificContent])

    var birthOfDay = "";


    function checkValidate() {
        if(purchaser === "") {
            setIsAlertForPurchaser(true);
        }else{
            setIsAlertForPurchaser(false); 
        }
        
        if(furigana === "") {
            setIsAlertForFurigana(true);
        }else{
            setIsAlertForFurigana(false);
        }

        if (email === "") {
            setIsAlertForEmail(true);
        } else {
            setIsAlertForEmail(false);
        }

        if (year !== ""  && month !== "" && day !== "") {
            birthOfDay = `${year}/${month}/${day}`;
        }
    }

    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>購入者情報を入力</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table className="iPad/iPadMini:w-11/12 md:w-6/12">
                            <tbody>
                                <TrText text="お名前"/>
                                <TrTextField id="purchaser-name" placeholder="お名前（必須）" required={true} isAlert={isAlertForPurchaser} onChange={inputPurchaser}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="お名前（フリガナ）"/>
                                <TrTextField id="purchaser-kana-name" placeholder="お名前（フリガナ）（必須）" required={true} isAlert={isAlertForFurigana} onChange={inputFurigana}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="メールアドレス"/>
                                <TrTextField id="email" placeholder="メールアドレス（必須）" required={true} isAlert={isAlertForEmail} onChange={inputEmail}/>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="生年月日"/>
                                <tr>
                                    <td>
                                        <Select text="年" start={2022} stop={1922} step={-1} onChange={inputYear}/>
                                        &emsp;
                                        &emsp;
                                        <Select text="月" start={1} stop={12} step={1} onChange={inputMonth}/>
                                        &emsp;
                                        &emsp;
                                        <Select text="日" start={1} stop={31} step={1} onChange={inputDay}/>
                                    </td>
                                </tr>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="性別"/>
                                <tr>
                                    <td>
                                        <form onChange={inputSex}>
                                            <RadioButton name="sex" value="man" text="男性"/>
                                            &emsp;
                                            &emsp;
                                            <RadioButton name="sex" value="woman" text="女性"/>
                                            &emsp;
                                            &emsp;
                                            <RadioButton name="sex" value="other" text="その他"/>
                                        </form>
                                    </td>
                                </tr>
                                <TrSpace/>
                                <TrSpace/>
                                <TrText text="Chermoを知ったきっかけ"/>
                                <tr>
                                    <td>
                                        <form onChange={inputHowDidChermoKnow}>
                                            <RadioButton name="how-did-you-know" value="twitter" text="Twitter"/>
                                            &emsp;
                                            &emsp;
                                            <RadioButton name="how-did-you-know" value="facebook" text="Facebook"/>
                                            &emsp;
                                            &emsp;
                                            <RadioButton name="how-did-you-know" value="other" text="その他"/>
                                        </form>
                                    </td>
                                </tr> 
                                <TrSpace/>
                                <TrTextArea id="other-specific-content" placeholder="その他（Chermoを知ったきっかけ）の具体的内容（任意）" isAlert={false} onChange={inputOtherTextAreaValue}/>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <FormPageButton
                            text="次へ進む"
                            onClick={() => {
                                checkValidate();
                                dispatch(setPurchaserInfo(purchaser, furigana, email, birthOfDay, sex, howDidChermoKnow, otherSpecificContent));
                            }}
                        />
                    </div>
                </main>
        </div>
    );
};